import { StoreImageEnum as r } from "../../../enums/store-image-enum.mjs";
import { ProductTypeEnum as o } from "../../../items/product/enums/product-type-enum.mjs";
const u = (e) => {
  switch (e) {
    case o.download:
      return r.product_download_cover;
    case o.eCourse:
      return r.e_course_cover;
    case o.physicalProduct:
      return r.physical_product_cover;
  }
};
export {
  u as getDefaultCoverByProductType
};
